import { environment } from "src/environments/environment";
import { errorHandler } from "src/app/util/errorHandler";
import { Router } from "@angular/router";
import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-fund-wallet",
  templateUrl: "./fund-wallet.component.html",
})
export class FundWalletComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router) {}

  loading = false;
  redirecting = false;
  notification = {};
  fundWalletTypes: any[] = [];
  selectedWalletType: any = null;
  fundWalletAmount: number = 0;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    this.fetchFundableWalletTypes();
  }

  fetchFundableWalletTypes(): void {
    this.loading = true;
    const baseUrl = `${environment.BASE_URL}/payments/fundableWalletTypes`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.fundWalletTypes = res.Data ?? [];
        }
      },
      error: (err: any) => {
        this.notification = errorHandler(err);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  selectWalletType(wt: any): void {
    this.selectedWalletType = wt;
    this.fundWalletAmount = wt.SuggestedAmount || 0;
  }

  submit(): void {
    if (!this.selectedWalletType || !this.fundWalletAmount) return;

    this.loading = true;
    this.notification = {};

    const callBackUrl = `${environment.BASE_URL}/payments/RedirectFromTrazgate?company=${authData().Company}`;
    const baseUrl = `${environment.BASE_URL}/payments/fundWalletWithTranzgate`;
    const body = {
      TranzgateClientNo: this.selectedWalletType.TranzgateClientId,
      TranzgatePaymentCode: this.selectedWalletType.TranzgatePaymentCode,
      OverpaymentCollectionTypeId: this.selectedWalletType.OverpaymentCollectionTypeId,
      Amount: this.fundWalletAmount,
    };

    this.httpClient.post(baseUrl, body, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          const { ResponseText, StudentFullName } = res.Data;
          let URL = `${environment.TRANZGATE_URL}`;
          URL += `MakePayment.aspx?id=${ResponseText}`;
          URL += `&allowupdate=1`;
          URL += `&customername=${StudentFullName}`;
          URL += `&returnurl=${encodeURIComponent(callBackUrl)}`;
          this.redirecting = true;
          location.href = URL;
        } else {
          this.notification = { error: true, message: res.Message };
          this.loading = false;
        }
      },
      error: (err: any) => {
        this.notification = errorHandler(err);
        this.loading = false;
      },
    });
  }
}
